import { Color, Icon, Spacing } from 'zens-storybook'
import React, { ReactNode, useState } from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  row: {
    height: 50,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: Spacing.S,
  },
  content: {
    flex: 1,
    justifyContent: 'center',
  },
  chevron: {
    marginLeft: Spacing.XS,
    color: Color.simplyWhite,
  },
  rotated: {
    transform: [{ rotate: '180deg' }],
  },
  details: {
    paddingHorizontal: Spacing.M,
  },
})

interface Props {
  content?: ReactNode
  details?: ReactNode
}
const ListItem = (props: Props) => {
  const { content, details } = props
  const [showdetails, setShowDetails] = useState(false)

  const title = <View style={styles.content}>{content}</View>

  return (
    <View style={styles.container}>
      {details ? (
        <>
          <TouchableOpacity
            style={styles.row}
            onPress={() => setShowDetails(!showdetails)}
            testID="TestListItem.ShowDetails"
          >
            {title}
            <Icon name="down" style={[styles.chevron, showdetails && styles.rotated]} size="S" />
          </TouchableOpacity>
          {showdetails && <View style={styles.details}>{details}</View>}
        </>
      ) : (
        <View style={styles.row}>{title}</View>
      )}
    </View>
  )
}

export default ListItem
